import { apiClient } from "./client";

export async function fetchProfessionalBilling() {
  const res = await apiClient.get("/professional/billing");
  return res.data;
}

export async function fetchInstitutionBilling() {
  const res = await apiClient.get("/institution/billing");
  return res.data;
}

export async function fetchOrganisationBilling() {
  const res = await apiClient.get("/organisation/billing");
  return res.data;
}

export async function retryInvoiceEmail(paymentId) {
  const res = await apiClient.post(
    `/payments/${paymentId}/invoice-email/retry`,
  );
  return res.data;
}

export async function downloadInvoicePdf(paymentId, invoiceNumber = "invoice") {
  const response = await apiClient.get(`/payments/${paymentId}/invoice-pdf`, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: "application/pdf" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `Invoice-${invoiceNumber}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export async function downloadSubscriptionInvoicePdf(
  kind = "organisation",
  invoiceNumber = "subscription",
) {
  const endpoint =
    kind === "institution"
      ? "/institution/subscription-invoice/pdf"
      : "/organisation/subscription-invoice/pdf";
  const response = await apiClient.get(endpoint, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: "application/pdf" }),
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `Invoice-${invoiceNumber}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
}
